<template>
  <div v-if="bannerVisible" class="expiration-banner bg-primary-500 ma-4 pa-4 rounded-lg d-flex justify-space-between">
    <div class="d-flex">
      <v-icon icon="mdi-alert-circle-outline" class="mr-2" color="tertiary-900" />
      <i18n-t keypath="expiration-banner.title" tag="p">
        <template #link>
          <router-link to="/products" class="text-tertiary-900 text-decoration-none">{{
            t("expiration-banner.link")
          }}</router-link>
        </template>
      </i18n-t>
    </div>

    <v-icon icon="mdi-close" @click="bannerVisible = false" />
  </div>
</template>

<script setup lang="ts">
import { getExpiredOrExpiringSubscriptionsCount } from "@/services/product-service";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useAuthStore } from "@/store/auth";

const { t } = useI18n();
const auth = useAuthStore();
const bannerVisible = ref(false);

// auth.user is only populated once the SUBSCRIBE_USER query resolves in
// App.vue, which happens after (and independently from) the SIGNED_IN auth
// event — watching auth.user directly avoids racing that async profile load.
watch(
  () => auth.user,
  (user) => {
    if (user && (auth.isAnyCompanyAdmin() || auth.isSiteManager())) {
      getExpiredOrExpiringSubscriptionsCount()
        .then((count) => {
          bannerVisible.value = count > 0;
        })
        .catch((e) => {});
    } else {
      bannerVisible.value = false;
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.expiration-banner {
  border: 2px solid rgb(var(--v-theme-tertiary-900));
}
</style>
